import { createReducer } from '@reduxjs/toolkit';

import { IHintListData, IHintsReducer } from '../hints/types';

import { loadHintsSiteStart, loadHintsSiteSuccess } from './actions';

const initialState: IHintsReducer = {
  isLoading: false,
  isLoaded: false,
  data: {} as IHintListData,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loadHintsSiteStart, (state) => ({ ...state, isLoading: true }))
    .addCase(loadHintsSiteSuccess, (state, action) => ({ ...state, isLoading: false, isLoaded: true, data: action.payload }));
});
